// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__vqBbl","label":"LabeledBox_label__3sO1m"};